import { useGate, useUnit } from 'effector-react';
import { Control } from '@unicorn/control';
import type { FormInstance } from '@unicorn/effector-form';
import {
  ObjectsTreeControlGate,
  $objects,
  $isLoading,
  defaultObjectTypes,
} from './model';
import type { ObjectType } from './types';

type Props<T> = {
  label?: string;
  form: FormInstance<T>;
  name: string;
  objectTypes?: ObjectType[];
  isCollapsible?: boolean;
  isSearchable?: boolean;
  visibleItemsLimit?: number;
  showOnlySelectedBranches?: boolean;
};

export const ObjectsTreeControl = <T,>({
  objectTypes = defaultObjectTypes,
  ...props
}: Props<T>) => {
  useGate(ObjectsTreeControlGate, { objectTypes });
  const [objects, isLoading] = useUnit([$objects, $isLoading]);

  return <Control.Tree items={objects} isLoading={isLoading} {...props} />;
};
